// extracted by mini-css-extract-plugin
export default {"datesFromTo":"date_datesFromTo__9qx94","dateTo":"date_dateTo__dUTkn","dateFrom":"date_dateFrom__mjOk7","icon":"date_icon__+od0e","dateDetails":"date_dateDetails__mh6mD"};